export const API_URL = "http://localhost";
export default API_URL;
